bq.global.tooltipSetup = function() {
  if (Modernizr.appleios) {
    $('[data-toggle="tooltip"]').each(function() {
      $(this)
        .tooltip({
          container: $(this).data('container') || false,
          placement: $(this).data('placement') || 'auto',
          trigger: 'click'
        })
        .on('shown.bs.tooltip', function() {
          var thiz = $(this);
          setTimeout(function() {
            thiz.tooltip('hide');
          }, 1000);
        });
    });
  } else {
    $('[data-toggle="tooltip"]').each(function() {
      $(this).tooltip({
        container: $(this).data('container') || false,
        placement: $(this).data('placement') || 'auto'
      });
    });
  }
};

$(document).on('click', function(){
  $('.tooltip:visible').hide();
});

bq.init.push(bq.global.tooltipSetup);
